module.exports = require('./dist/src/components/input-with-options');
